import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_153: DocMigration = {
  maxSchemaVersion: "0.0.153",
  description: "Swap datum types",
  apply(json: any) {
    for (const facadeId in json.facades) {
      const facade = json.facades[facadeId];
      const { datumTable } = facade;

      for (const datumId in datumTable) {
        const datum = datumTable[datumId];
        datumTable[datumId] = {
          ...datum,
          type: datum.type === "HORIZONTAL" ? "VERTICAL" : "HORIZONTAL",
        };
      }
    }

    return json;
  },
};

export default migration_0_0_153;
